// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".person-name[data-v-2097562e]{display:flex}.person-name__label[data-v-2097562e]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.person-name__age[data-v-2097562e]{padding-left:5px;white-space:nowrap}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
